import { Sortable } from "sortablejs"

// With forceFallback, SortableJS drags a deep clone of the dragged element (Sortable.ghost) that
// stays in the page for the whole drag. Left alone, Stimulus connects every controller inside that
// clone and registers its targets/actions with the controllers around it — and a nested controller
// whose disconnect destroys a Sortable aborts the very drag that made the clone (Sortable#destroy
// calls _onDrop on the shared drag state).
const STIMULUS_ATTRIBUTE = /^data-(controller|action|.+-target|.+-outlet)$/

export function detachFromStimulus(root) {
  if (!root) return

  ;[root, ...root.querySelectorAll("*")].forEach((element) => {
    Array.from(element.attributes)
      .filter((attribute) => STIMULUS_ATTRIBUTE.test(attribute.name))
      .forEach((attribute) => element.removeAttribute(attribute.name))
  })
}

// SortableJS appends the ghost synchronously right before it fires "start", so this runs before
// Stimulus's MutationObserver ever sees the clone.
export function detachGhostOnStart() {
  detachFromStimulus(Sortable.ghost)
}
